import React from "react";
import { resolveImg } from "../../lib/api";
import { useLabText } from "../../lib/labText";
import { ExperimentCard } from "./ExperimentCard";

const btn = "text-[11px] uppercase tracking-[0.25em] px-6 py-3.5 transition-colors disabled:opacity-40 disabled:cursor-not-allowed";

export const ReleaseSection = ({ r, approved, me, voices, onBuy, onEvaluate, stages }) => {
  const { t, pick, aed } = useLabText();
  const canBuy = r.status === "available" && approved;
  const purchased = new Set(me?.purchased || []);
  const statusLabel = r.status === "available" ? `${r.sets_available} ${r.sets_available === 1 ? t("set_left") : t("sets_left")}` : t(`status_${r.status}`);
  return (
    <section data-testid={`lab-release-${r.code}`} className="border-t border-[#262421] pt-12">
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-10 items-start">
        <div className="lg:sticky lg:top-28">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#C49A6C]" dir="ltr">{r.code}{r.release_date ? ` · ${r.release_date}` : ""}</p>
          <h2 className="serif text-4xl md:text-5xl mt-3 leading-tight">{pick(r, "title")}</h2>
          {pick(r, "description") && <p className="text-[#B8B0A4] mt-5 leading-relaxed whitespace-pre-line">{pick(r, "description")}</p>}
          {r.images?.[0] && <img src={resolveImg(r.images[0])} alt="" className="mt-6 w-full aspect-[16/10] object-cover border border-[#262421]" />}
          <div className="mt-7 border border-[#262421] p-5">
            <div className="flex items-baseline justify-between gap-3">
              <span className="text-[11px] uppercase tracking-[0.25em] text-[#8A857D]">{t("set")} · {r.experiments.length} {t("samples")}</span>
              <span className="serif text-3xl text-[#F2EBE1]" dir="ltr" data-testid={`lab-price-${r.code}`}>{aed(r.set_price)}</span>
            </div>
            {r.discount_pct > 0 && <p className="text-xs text-[#8A857D] mt-1 text-end" dir="ltr"><s>{aed(r.set_price_before)}</s> · {r.discount_pct}% {t("discount")}</p>}
            <p className="text-xs text-[#C49A6C] mt-3" data-testid={`lab-availability-${r.code}`}>{statusLabel}</p>
            <div className="flex flex-col sm:flex-row gap-3 mt-5">
              <button onClick={() => onBuy(r, "set")} disabled={!canBuy || r.sets_available < 1} data-testid={`lab-buy-set-${r.code}`}
                className={`${btn} flex-1 bg-[#C49A6C] text-[#0B0A08] hover:bg-[#E7CBA9]`}>
                {r.status !== "available" ? t(`status_${r.status}`) : !approved ? t("approved_only") : r.sets_available < 1 ? t("sold_out") : t("buy_set")}
              </button>
              {r.allow_individual && (
                <button onClick={() => onBuy(r, "single")} disabled={!canBuy} data-testid={`lab-buy-single-${r.code}`}
                  className={`${btn} border border-[#C49A6C] text-[#C49A6C] hover:bg-[#C49A6C] hover:text-[#0B0A08]`}>{t("buy_single")}</button>
              )}
            </div>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          {r.experiments.map((e) => (
            <ExperimentCard key={e.id} e={e} showSingle={r.allow_individual} purchased={purchased.has(e.id)} evalState={me?.evaluations?.[e.id]}
              onEvaluate={onEvaluate} voices={voices[e.id]} stages={stages} />
          ))}
        </div>
      </div>
    </section>
  );
};
